<template>

    <div class="profile-dashboard__subscriptions-list">
        <div class="profile-dashboard__subscriptions-slider" v-if="payments.length">
            <swiper ref="swiper" class="swiper" :options="swiperOptionsAnimal">

                <swiper-slide v-for="(subscript, idx) in payments" :key="idx">

                    <div class="subscription__item">
                        <div class="subscription__item-inner d-flex">
                            <div class="subscription__header">
                            <span class="subscription__status">
                                {{ checkStatus(subscript.status) }}
                            </span>
                                <div class="subscription__image">
                                    <a :href="`/projects/${subscript.userCardCheck.project_id}`"
                                       v-if="subscript.userCardCheck.project">
                                        <img v-if="subscript.userCardCheck.project.avatar"
                                             :src="'/storage/' + (subscript.userCardCheck.project.avatar.path.replace('original', 'preview_l'))"
                                             alt="">
                                    </a>
                                    <a :href="`/pets/${subscript.userCardCheck.pet_id}`" v-else>
                                        <img v-if="subscript.userCardCheck.pet.avatar"
                                             :src="'/storage/' + (subscript.userCardCheck.pet.avatar.path.replace('original', 'preview_l'))"
                                             alt="">
                                    </a>
                                </div>
                                <a :href="`/projects/${subscript.userCardCheck.project_id}`" class="subscription__title"
                                   v-if="subscript.userCardCheck.project"
                                   v-text="subscript.userCardCheck.project.name"></a>
                                <a :href="`/pets/${subscript.userCardCheck.pet_id}`" class="subscription__title" v-else
                                   v-text="subscript.userCardCheck.pet.name"></a>
                                <!--                                <div class="subscription__info" v-if="subscript.autoPay && subscript.autoPay.status === 'active'">
                                                                    Следующие
                                                                    <span v-text="(subscript.total_sum + ' ' + subscript.currency.code)" v-if="subscript.tips_sum"></span>
                                                                    <span v-text="(subscript.amount + ' ' + subscript.currency.code)" v-else></span> спишутся
                                                                    <span class="date" v-if="subscript.autoPay.next_payment_date"
                                                                          v-text="moment(subscript.autoPay.next_payment_date).locale('ru').format('DD MMMM')"></span>
                                                                </div>-->
                                <!--                                <div class="subscription__info" v-else-if="subscript.autoPay && subscript.autoPay.status === 'suspended'">-->
                                <!--                                    Подписка на помощь приостановлена-->
                                <!--                                </div>-->
                                <!--                                <div class="subscription__info" v-else>-->
                                <!--                                    Подписка на помощь отменена-->
                                <!--                                </div>-->
                            </div>

                            <div class="subscription__body" v-if="subscript.payment_method.last4">
                                <div class="subscription__body-item d-flex">
                                    <div class="subscription__body-icon d-flex">
                                        <img src="/assets/images/icons/card.svg" alt="">
                                    </div>
                                    <div class="subscription__body-info">CARD: <span
                                        class="text-uppercase">{{ subscript.payment_method.brand }}</span>
                                        ****{{ subscript.payment_method.last4 }}
                                    </div>
                                </div>
                                <div class="subscription__body-item d-flex mt-2">
                                    <div class="subscription__body-icon d-flex">
                                        <img src="/assets/images/icons/money.svg" alt="">
                                    </div>
                                    <div class="subscription__body-info">${{ subscript.price.amount }} / <span
                                        class="text-capitalize">${{ subscript.price.interval }}</span></div>
                                </div>
                            </div>

                            <div class="subscription__footer d-flex">
                                <!--
                                                                <button @click.prevent="setStatus('suspended', subscript.autoPay.user_card_check_id)"
                                                                        class="subscription__btn" v-if="subscript.autoPay.status === 'active'">Приостановить платежи</button>

                                                                <button @click.prevent="setStatus('active', subscript.autoPay.user_card_check_id)"
                                                                        class="subscription__btn" v-if="subscript.autoPay.status === 'suspended'" style="color: #fff; background: #2E76E4">Возобновить платежи</button>
                                -->

                                <button class="subscription__btn subscription__btn--deactive"
                                        @click="cancelSubscribe(subscript)">{{$store.getters.t('user_dashboard_cancel_payments')}}
                                </button>
                            </div>

                        </div>
                    </div>

                </swiper-slide>

<!--                <swiper-slide v-for="(discount, idx) in discounts" :key="`discount-${discount.id}`">

                    <div class="discounts__item">
                        <div class="discounts__item-inner d-flex">

                            <div class="discounts__header">
                                <div class="discounts__image">
                                    <img :src="`${discount.image}`" alt="" v-if="discount.image">
                                </div>
                                <div class="discounts__title" v-text="discount.title"></div>
                                <div class="discounts__info" v-if="discount.info" v-text="discount.info"></div>
                            </div>

                            <div class="discounts__body d-flex">
                                <div class="discounts__content" v-html="discount.description"></div>
                                <div class="discounts__more" v-if="discount.more">
                                    {{discount.more}}
                                    <a :href="discount.link" v-text="discount.link"></a>
                                </div>
                            </div>

                        </div>
                    </div>

                </swiper-slide>-->

            </swiper>

            <div class="slider-navigations">
                <div id="dashboard-subs-prev" class="swiper-button-prev" slot="button-prev"></div>
                <div id="dashboard-subs-next" class="swiper-button-next" slot="button-next"></div>
            </div>

        </div>
<!--        <div class="discounts__grid d-flex" v-else>

            <div class="discounts__item" v-for="(discount, idx) in discounts" :key="idx">
                <div class="discounts__item-inner d-flex">

                    <div class="discounts__header">
                        <div class="discounts__image">
                            <img :src="`${discount.image}`" alt="" v-if="discount.image">
                        </div>
                        <div class="discounts__title" v-text="discount.title"></div>
                        <div class="discounts__info" v-if="discount.info" v-text="discount.info"></div>
                    </div>

                    <div class="discounts__body d-flex">
                        <div class="discounts__content" v-html="discount.description"></div>
                        <div class="discounts__more" v-if="discount.more">
                            {{discount.more}}
                            <a :href="discount.link" v-text="discount.link"></a>
                        </div>
                    </div>

                </div>
            </div>

        </div>-->
    </div>

</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
    name: "UserDashboardSubscriptions",
    components: { Swiper, SwiperSlide },
    data(){
        return{
            moment: window.moment,
            discounts:[
                // {
                //     id: 1,
                //     image:'/assets/images/discounts/discount1.svg',
                //     title: 'Ваш промокод в интернет-гипермаркете 21vek:',
                //     info: 'SUTHX',
                //     description:'Скидка <span>5%</span> на товары из категории зоотовары. Скидка <span>3%</span> на весь остальной ассортимент за исключением стоп-брендов.',
                //     more: 'Подробнее о правилах использования промокода:',
                //     link: 'https://www.21vek.by/info/about_promocodes.html',
                // },
                // {
                //     id: 2,
                //     image:'/assets/images/discounts/discount2.jpg',
                //     title: 'Ваша скидка в ветеринарные клиники Доктор Вет:',
                //     info: '20%',
                //     description:'Для волонтеров платформы при посещении клиники Доктор Вет по талону Saveus действует скидка 20%',
                //     more: 'Подробнее о скидке:',
                //     link: 'http://dv.by/',
                // },

            ],
            payments: [],
            swiperOptionsAnimal: {
                slidesPerView: 3,
                spaceBetween: 24,
                navigation: {
                    nextEl: '#dashboard-subs-next',
                    prevEl: '#dashboard-subs-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1, // or 'auto'
                        spaceBetween: 10,
                    },
                    768:{
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                },
            },
        }
    },

    mounted(){
        this.getPayments()
    },

    methods:{
        cancelSubscribe(subscription) {
            let url = `/api/payments/subscriptions/${subscription.subscription_id}/cancel`;

            axios.post(url).then(response => {
                response = response.data;

                if (response.success) {
                    this.payments = response.data;
                }
            })
        },

        checkStatus(objStatus) {
            if (!objStatus) return;

            let status = null;

            switch (objStatus){
                case 'active':
                    status = 'user_dashboard_sub_status_active';
                    break;
                case 'suspended':
                    status = 'user_dashboard_sub_status_suspended';
                    break;
                case 'cancelled':
                    status = 'user_dashboard_sub_status_cancelled';
                    break;
                case 'auto_cancelled':
                    status = 'user_dashboard_sub_status_auto_cancelled';
                    break;
                default:
                    break;
            }

            return this.$store.getters.t(status);
        },

        setStatus(status, checkId){
            let url = `/api/payments/autopayment-status`

            axios.post(url,{
                payment_id: checkId,
                status: status
            })
                .then(response => {
                    response = response.data;

                    if(response.success){
                        this.getPayments()
                    }

                })
                .catch()

        },

        getPayments(){
            let url = `/api/payments/subscriptions`;

            axios.get(url).then(response => {
                response = response.data;

                if (response.success) {
                    this.payments = response.data;
                }
            })
                .catch()


        }
    }

}
</script>

<style scoped>

</style>
